import React from 'react';
const { useState, useEffect } = React;
import { teamCall } from '../../teamClient.js';
import { TEAM_ERRORS } from '../../teamMessages.js';

// For a collaborator of the central base: says who Oike recognizes them as (their Users record, by the email of their
// login) and, when it cannot, why they see no companies. Never shown to anyone else.
export default function TeamNotice() {
  const [s, setS] = useState(null);
  const load = () => { setS(null); teamCall({ action: 'me' }).then(setS).catch(e => setS({ error: e.message })); };
  useEffect(() => { load(); }, []);
  if (!s || (s.identity?.status === 'ok')) return s?.identity?.status === 'ok'
    ? <div style={{ fontSize: 12, color: 'var(--globant-muted)', margin: '0 0 10px' }}>Trabajás como {s.identity.name || 'colaborador'}: ves solo las empresas que Ale te asignó.</div>
    : null;
  const text = s.error || (s.identity?.status === 'ambiguous' ? TEAM_ERRORS.team_user_ambiguous : TEAM_ERRORS.team_user_missing);
  return (
    <div role="alert" style={{ border: '1px solid rgba(245,158,11,0.5)', background: 'rgba(245,158,11,0.08)', borderRadius: 10, padding: '10px 12px', margin: '0 0 12px', fontSize: 13, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <span style={{ flex: '1 1 260px' }}>{text} Mientras tanto no verás empresas ni contactos.</span>
      <button type="button" className="action-btn" style={{ fontSize: 11, padding: '2px 8px' }} onClick={load}>Reintentar</button>
    </div>
  );
}
